// src/axiosConfig.js
import axios from 'axios';


axios.defaults.baseURL = localStorage.getItem('BE_Domain');
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const originalRequest = error.config;

        if (error.response) {
            // Check if the request URL is not the login URL
            if (originalRequest.url !== '/sign-in') {
                if (error.response.status === 419) {
                    window.location.href = '/sign-in?message=session_expired';
                } else if (error.response.status === 401) {
                    window.location.href = '/sign-in?message=validation_error';
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axios;
